import lozad from 'lozad';
import Swiper from 'swiper';
import VimeoPlayer from '@vimeo/player';
import 'is-in-viewport';

let winWidth = $(window).width(),
    xs       = true,
    sm       = false,
    md       = false,
    lg       = false,
    xl       = false;

xs;

function mobileCheck() {
  if ( '576' > winWidth ) {
    xs = true;
    sm = false;
    md = false;
    lg = false;
    xl = false;
  }

  if ( '576' <= winWidth ) {
    xs = false;
    sm = true;
    md = false;
    lg = false;
    xl = false;
  }

  if ( '768' <= winWidth ) {
    xs = false;
    sm = false;
    md = true;
    lg = false;
    xl = false;
  }

  if ( '992' <= winWidth ) {
    xs = false;
    sm = false;
    md = false;
    lg = true;
    xl = false;
  }

  if ( '1200' <= winWidth ) {
    xs = false;
    sm = false;
    md = false;
    lg = false;
    xl = true;
  }
}

mobileCheck();

$(window).resize(function() {
  winWidth = $(window).width();
  mobileCheck();
});

export default {
  init() {
    // JavaScript to be fired on all pages

    /**
     * Lazy loading
     */
    lozad('.lozad', {
      rootMargin: '400px 0px',
      load: function(el) {
        el.src = el.dataset.src;
        el.onload = function() {
          el.classList.add('is-loaded')
        }
      },
    }).observe();

    /**
     * Full pic image size loading
     */
    let sectionFullPicResizer = function() {
      $('.section-full-pic').each(function() {
        if (xs && $(this).data('size-xs')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-xs') + ')');
        }

        if (sm && $(this).data('size-sm')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-sm') + ')');
        }

        if (md && $(this).data('size-md')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-md') + ')');
        }

        if (lg && $(this).data('size-lg')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-lg') + ')');
        }

        if (xl && $(this).data('size-xl')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-xl') + ')');
        }
      });
    };

    sectionFullPicResizer();

    $(window).resize(function() {
      sectionFullPicResizer();
    });

    /**
     * Videos
     * Initialize players and auto-play/pause based on modal state
     */
    let $videoModalBtnPlay = $('.btn-play[data-toggle="modal"]');

    $videoModalBtnPlay.each(function() {
      let modalId      = $(this).data('target'),
          $targetModal = $(modalId),
          $videoEl     = $targetModal.find('iframe.vimeo'),
          videoElId    = $videoEl.attr('id');

      if ('undefined' !== typeof videoElId) {
        let videoObj    = document.getElementById(videoElId),
            videoPlayer = new VimeoPlayer(videoObj);

          $targetModal.on('shown.bs.modal', function() {
            videoPlayer.play();
          });

          $targetModal.on('hide.bs.modal', function() {
            videoPlayer.pause();
          });
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(window).resize(function() {
      winWidth = $(window).width();
      mobileCheck();
    });

    $(window).scroll(function() {
      if (0 !== $(window).scrollTop()) {
        $('body').addClass('is-not-top');
      } else {
        $('body').removeClass('is-not-top');
      }
    });

    let yOffset = 120;

    if (md) {
      yOffset = 140;
    }

    /**
     * Internal anchor scroll to
     * (Active links will be handled by scrollspy below)
     */
    $('.nav a[href^="#"]').on('click', function(e) {
      e.preventDefault();

      let target = $(this).attr('href');

      $('html, body').animate({
        scrollTop: ($(target).offset().top - yOffset),
      }, 800, 'swing');
    });

    /**
     * Custom scrollspy
     */

    let gbScrollspy = function() {
      let sections = [];

      $('.nav-scrollspy .nav-link').each(function(i) {
        sections[i] = $(this).attr('href');
      });

      for (let i = 0; i < sections.length; i ++) {
        let section   = sections[i],
            $links    = $('.nav-secondary .nav-link'),
            $thisLink = $('.nav-secondary .nav-link[href="' + section + '"]');

        if ($(section).is(':in-viewport(-' + yOffset + ')')) {
          $links.not($thisLink).removeClass('is-active').blur();
          $thisLink.addClass('is-active');
        } else {
          $thisLink.removeClass('is-active').blur();
        }
      }
    };

    gbScrollspy();

    $(window).scroll(function() {
      gbScrollspy();
    });

    /**
     * Collapsible lists
     */
    $('.collapsible-list dd').slideUp();

    $('.collapsible-list dt a').on('click', function(e) {
      e.preventDefault();
      let dt = $(this).parent('dt'),
          dd = dt.next('dd');

      if (!dt.hasClass('active')) {
        $('dd').not(dd).slideUp();
        $('dt').not(dt).removeClass('active');
        dt.addClass('active');
        dd.slideDown(200);
      } else {
        dt.removeClass('active');
        $(this).blur();
        dd.slideUp(100);
      }
    });


    $('[data-bg-img-hover]').each(function() {
      let originalImgBg = $(this).attr('style');

      $(this)
        .on('mouseenter', function() {
          $(this).attr('style', $(this).data('bg-img-hover'));
        })
        .on('mouseleave', function() {
          $(this).attr('style', originalImgBg);
        });
    });

    /**
     * Quotes
     * https://idangero.us/swiper/api/
     */

    let quotesSwiperArgs = {
      init:       true,
      autoplay:   {
        delay: 6000,
      },
      effect:     'fade',
      speed:      500,
      fadeEffect: {
        crossFade: true,
      },
    };

    new Swiper('.quotes-slider .swiper-container', quotesSwiperArgs);

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js